<template>
  <div class="filterOptions">
    <h1>
      Refine your selection
    </h1>
    <div class="options">
      <div>
        <h4>Gender</h4>
        <input type="checkbox" name="Gender" value="Male" v-model="gender" />
        Male
        <input type="checkbox" name="Gender" value="Female" v-model="gender" />
        Female
      </div>
      <div>
        <h4>Size</h4>
        <input type="checkbox" name="Size" value="small" v-model="size" />Small
        <input
          type="checkbox"
          name="Size"
          value="medium"
          v-model="size"
        />Medium
        <input type="checkbox" name="Size" value="large" v-model="size" />Large
      </div>
      <div>
        <h4>Age</h4>
        <input type="checkbox" name="Age" value="18-25" v-model="age" />18-25
        <input type="checkbox" name="Age" value="26-35" v-model="age" />26-35
        <input type="checkbox" name="Age" value="36-45" v-model="age" />36-45
        <input type="checkbox" name="Age" value="45+" v-model="age" />45+
      </div>
    </div>
    <button @click="SendFilterOptions()">Filter</button>
    <div>
      <h1>Feeling lazy?</h1>
      <faceDetector
        @detected="updateFilterFromFace"
        :threshold="genderProbability"
      />
    </div>
  </div>
</template>

<script>
import FaceDetector from "./FaceDetector.vue";
export default {
  data: function() {
    return {
      genderProbability: 0.95,
      gender: [],
      size: [],
      age: [],
      price: {
        lt: 0,
        gt: 8888,
      },
    };
  },
  methods: {
    updateFilterFromFace(data) {
      const gender = data.gender;
      const age = data.age;

      if (gender == "male") {
        this.gender = ["Male"];
      } else if (gender == "female") {
        this.gender = ["Female"];
      }
      if (age < 26) {
        this.age = ["18-25"];
      } else if (age < 36) {
        this.age = ["26-35"];
      } else if (age < 46) {
        this.age = ["36-45"];
      } else if (age > 45) {
        this.age = ["45+"];
      }
      if (data.genderProbability > this.genderProbability) {
        this.SendFilterOptions();
      }
    },
    SendFilterOptions: function() {
      let gender = this.addToQuery("gender", this.gender);
      let size = this.addToQuery("size", this.size);
      let age = this.addToQuery("age", this.age);

      let q = "";
      q = this.concatQuery(gender, size);
      q = this.concatQuery(q, age);

      this.$emit("filter", q);
    },
    addToQuery: function(name, data) {
      let query = "";
      if (data.length != 0) {
        query += name + "=";
        for (let i = 0; i < data.length; i++) {
          const d = data[i];
          query += d;
          if (i + 1 < data.length) {
            query += ",";
          }
        }
      }
      return query;
    },
    concatQuery: function(q1, q2) {
      if (q1 === "") {
        return q2;
      } else if (q2 === "") {
        return q1;
      } else {
        return q1 + "&" + q2;
      }
    },
  },
  components: {
    FaceDetector,
  },
};
</script>

<style lang="scss" scoped>
.filterOptions {
  height: 100vh;
  // background: rgb(219, 218, 218);
  background: #bccbdec5;
  padding: 20px;
  h1 {
    font-size: 30px;
  }
  .options {
    h4 {
      margin-bottom: 5px;
    }
    input {
      margin: 5px;
    }
  }
  button {
    margin: 20px;
    margin-left: 0;
    padding: 5px 10px;
    font-weight: normal;
    font-size: 1em;
    letter-spacing: 0.5px;
    border: 1px transparent;
    border-radius: 5px;
    color: #f7f7f7;
    background-color: #2c3e50 ;
  }
}
</style>
